import fpFetch from "@/services/fpFetch";
import { BASE_API_URL } from "@/constants";

export interface IodlSourceData {
  sql: string;
  columns: string[];
  rows: Array<Array<string | number | null>>;
  reasoning: string;
}

/**
 * Lazy-load the full IODL/BNYM query + result set for a query answer. The
 * answer source map only carries IODL metadata (sql, columns, row count); the
 * rows are fetched here on demand when the user opens an IODL citation.
 */
export const getIodlSourceData = async (
  qid: string
): Promise<IodlSourceData> => {
  const response = await fpFetch(
    `${BASE_API_URL}/queryResults/getQueryAnswerIodlData?id=${qid}`
  );
  const data = await response.json();
  return {
    sql: data.sql ?? "",
    columns: data.columns ?? [],
    rows: data.rows ?? [],
    reasoning: data.reasoning ?? "",
  };
};
